<template>
  <div class="comment-section">
    <h5 class="mb-3">Comments ({{ totalCount }})</h5>
    <div class="mt-1 mb-2" v-if="!showForm">
      <b-button size="sm" variant="primary" @click="showForm = true">
        Add a Comment
      </b-button>
    </div>

    <div v-if="showForm" class="comment-item mt-2">
      <b-form @submit.prevent="submitComment">
        <b-form-textarea
          v-model="newComment"
          rows="2"
          placeholder="Write a comment..."
          required
        />
        <div class="d-flex align-items-center mt-2">
          <b-button
            size="sm"
            type="submit"
            variant="primary"
            :disabled="!newComment.trim() || posting"
          >
            {{ posting ? 'Sending...' : 'Send Comment' }}
          </b-button>
          <b-button size="sm" variant="secondary" class="ml-2" @click="cancelComment">
            Cancel
          </b-button>
        </div>
      </b-form>
    </div>

    <div v-if="loading">Loading comments...</div>

    <div v-else>
      <div v-if="comments.length > 0">
        <div v-for="(comment, idx) in displayedComments" :key="comment.id">
          <CommentItem :comment="comment" @reply="handleReply" />
        </div>
        <div v-if="comments.length > maxVisible">
          <b-button size="sm" variant="link" @click="toggleShowAll">
            {{ showAll ? 'Show less' : 'Show more comments' }}
          </b-button>
        </div>
      </div>

      <div v-else class="text-muted mt-2">No comments yet. Be the first to comment!</div>

    </div>
  </div>
</template>

<script>
import CommentItem from './CommentItem.vue'
import axios from 'axios'
import { BForm, BFormTextarea, BButton } from 'bootstrap-vue'

export default {
  components: { BForm, BFormTextarea, BButton, CommentItem },
  props: {
    podcastId: [String, Number],
    token: String
  },
  data() {
    return {
      comments: [],
      loading: true,
      posting: false,
      newComment: '',
      showAll: false,
      maxVisible: 3,
      showForm: false,
      totalCount: 0

    }
  },
  computed: {
    displayedComments() {
      const sorted = [...this.comments].sort((a, b) => b.time - a.time)
      return this.showAll ? sorted : sorted.slice(0, this.maxVisible)
    }
  },
  methods: {
    fetchComments() {
      this.loading = true
      axios
        .get(`${process.env.VUE_APP_API_HELPER_URL}/podcast/${this.podcastId}/comments`, {
          headers: { Authorization: this.token }
        })
        .then(res => {
          const raw = res.data.data || []

          this.totalCount = (res.data.total_comments || 0) + (res.data.total_replies || 0)

          const process = (list) => {
            return list.map(item => ({
              id: item.id,
              author: item.username,
              time: new Date(item.createdat).getTime(),
              text: item.comment,
              likes: 0,
              replies: item.replies ? process(item.replies).sort((a, b) => b.time - a.time) : [],
              parent_id: item.parent_id
            }))
          }

          this.comments = process(raw)
        })
        .catch(err => console.error('Gagal ambil komentar:', err))
        .finally(() => {
          this.loading = false
        })
    },
    submitComment() {
      if (!this.newComment.trim()) return
      this.posting = true
      const user = this.$store.getters['oauth/getActiveUser']

      axios
        .post(
          `${process.env.VUE_APP_API_HELPER_URL}/podcast/${this.podcastId}/comment`,
          {
            user_id: user.id,
            username: user.name,
            comment: this.newComment.trim(),
            parent_id: 0
          },
          {
            headers: {
              Authorization: this.token,
              'Content-Type': 'application/json'
            }
          }
        )
        .then(() => {
          this.newComment = ''
          this.showForm = false
          this.fetchComments()
        })
        .catch(err => console.error('Gagal kirim komentar:', err))
        .finally(() => {
          this.posting = false
        })
    },
    cancelComment() {
      this.newComment = ''
      this.showForm = false
    },
    handleReply(parentComment, replyObj) {
      this.posting = true
      const user = this.$store.getters['oauth/getActiveUser']

      axios
        .post(
          `${process.env.VUE_APP_API_HELPER_URL}/podcast/${this.podcastId}/comment`,
          {
            user_id: user.id,
            username: user.name,
            comment: replyObj.text,
            parent_id: parentComment.id
          },
          {
            headers: {
              Authorization: this.token,
              'Content-Type': 'application/json'
            }
          }
        )
        .then(() => this.fetchComments())
        .catch(err => console.error('Gagal kirim reply:', err))
        .finally(() => {
          this.posting = false
        })
    },
    toggleShowAll() {
      this.showAll = !this.showAll
    }
  },
  mounted() {
    this.fetchComments()
  }
}
</script>

<style scoped>
.comment-item {
  margin-bottom: 1.5rem;
}
</style>
